import React, {useState, useEffect} from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { register, passDoNot } from '../../redux/actions/authActions';
import 'react-phone-number-input/style.css';
import ReactPhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/dist/style.css'

import {
  Button,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col
} from "reactstrap";

const SignUp = ({ register, isAuthenticated, passDoNot }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    password2: ''
  });

  const { name, email, phone, password, password2 } = formData;

  const onChange = e => {
    console.log(e)
    setFormData({ ...formData, [e.target.name]: e.target.value })
  };

  const setPhone = e => {
    console.log(e)
    setFormData({...formData, phone: e})
  }

  const onSubmit = async e => {
    e.preventDefault();
    if(password !== password2) {
      passDoNot()
    } else {
      register({ name, email, password, phone });
    }
  };

  if(isAuthenticated) {
    return <Redirect to="/growers" />
  }

  return (
    <React.Fragment>
      <div className="text-center mt-4">
        <h1 className="h2">Pleasant Valley Farms</h1>
      </div>
      <div className="text-left mt-4">
        <p><code><i>
          "Here's to the crazy ones, the misfits, the rebels, the troublemakers, the round pegs in the square holes...<br/>The ones who are crazy enough to think that they can change the world, are the ones who do." - Steve
        </i></code></p>
      </div>

      <Card>
        <CardBody>
          <div className="m-sm-4">
            <Form onSubmit={e => onSubmit(e)}>
              <FormGroup>
                <Label>Name</Label>
                <Input
                  bsSize="lg"
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  value={name} onChange={e => onChange(e)}
                />
              </FormGroup>
              <FormGroup>
                <Label>Email</Label>
                <Input
                  bsSize="lg"
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  value={email} onChange={e => onChange(e)}
                />
              </FormGroup>
              <FormGroup>
                <Label>Phone Number</Label>
                <ReactPhoneInput
                  bsSize="lg"
                  defaultCountry={'us'}
                  autoFormat={false}
                  name="phone"
                  placeholder="Enter Phone Number"
                  value={phone} onChange={e => setPhone(e)}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>Password</Label>
                <Input
                  bsSize="lg"
                  type="password"
                  name="password"
                  placeholder="Enter password"
                  minlength="6"
                  value={password} onChange={e => onChange(e)}
                />
              </FormGroup>
              <FormGroup>
                <Label>Confirm Password</Label>
                <Input
                  bsSize="lg"
                  type="password"
                  name="password2"
                  placeholder="Enter password"
                  minlength="6"
                  value={password2} onChange={e => onChange(e) }
                />
              </FormGroup>
              <div className="text-center mt-3">
                <input type="submit" className="btn btn-primary" value="Sign Up" />
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
}

SignUp.propTypes = {
  register: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});


export default connect(mapStateToProps, { register, passDoNot })(SignUp);
